<template>
  <div class="flex flex-col w-full h-full gap-4">
    <div class="flex flex-col w-full gap-2">
      <span class="subtitle-bold section">שם הסניף</span>
      <input-text v-model="name" placeholder="לדוגמה: סניף תל אביב" type="text" />
      <span v-if="isMainBranch" class="text-xs text-gray-500">
        זהו שם הסניף בלבד — שם העסק ({{ businessTitle }}) לא ישתנה. בתזכורות ללקוחות יופיעו שם העסק והסניף.
      </span>
    </div>
    <div class="flex flex-col w-full gap-2">
      <span class="subtitle-bold section">כתובת</span>
      <input-text v-model="address" placeholder="רחוב, עיר" type="text" />
    </div>
    <div class="flex flex-col w-full gap-2">
      <span class="subtitle-bold section">טלפון</span>
      <input-text v-model="phone" placeholder="מספר טלפון לסניף" type="text" />
    </div>

    <drawer-footer
      :approveDisable="!name.trim()"
      :approveLoading="loading"
      :approveLabel="props.branch ? 'שמירה' : 'הוספת סניף'"
      @approve-click="submit"
      @cancel-click="$emit('close')"
    />
  </div>
</template>

<script lang="ts" setup>
import { type IBranch, MAIN_BRANCH_ID } from '@torim-app/types';
import { computed, ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useAdminStore } from '@app/stores';
import { trackEvent } from '@app/composables/posthog';

const props = defineProps<{ branch?: IBranch }>();
const emit = defineEmits(['done', 'close']);

const adminStore = useAdminStore();
const toast = useToast();

const isMainBranch = computed(() => props.branch?.id === MAIN_BRANCH_ID);
const businessTitle = computed(() => adminStore.getBusinessTitle);

const name = ref(props.branch?.name ?? '');
const address = ref(props.branch?.address ?? '');
const phone = ref(props.branch?.phone ?? '');
const loading = ref(false);

const submit = async (): Promise<void> => {
  if (!name.value.trim()) return;
  loading.value = true;
  try {
    const payload = { name: name.value.trim(), address: address.value.trim(), phone: phone.value.trim() };
    if (props.branch) {
      await adminStore.updateBranch(props.branch.id, payload);
      trackEvent('settings_branch_updated');
    } else {
      await adminStore.createBranch({ ...payload, active: true });
      trackEvent('settings_branch_created');
    }
    toast.success('עדכנו את הסניפים 😄');
    emit('done');
  } catch (e) {
    console.error(e);
    toast.error('לא הצלחנו לשמור את הסניף');
  } finally {
    loading.value = false;
  }
};
</script>

<style lang="scss" scoped></style>
